import React, { useEffect, useState, useCallback } from "react";
import { Tooltip, TextField, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Typography, Autocomplete, IconButton, CircularProgress } from "@mui/material";
import { callAPI } from "../../../axios";
import { getChainIdLS, isValidRole } from "../../../utils/utils";
import { useForm, Controller } from "react-hook-form";
import BasicModal from "../../core/BaseComponents/Modal";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClosedIcon from "@mui/icons-material/Close";
import { MdModeEditOutline } from "react-icons/md";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import dayjs from "dayjs";
import GlobalProps from "../../core/BaseComponents/TableWrapper/Global";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import { useSelector } from "react-redux";
// import Search from "../../core/BaseComponents/Search";
import { debounce } from 'lodash';
import Axios from "axios";

const CdsnsListMapping = (props) => {
    let userRoleCode = JSON.parse(localStorage.getItem("userDetails"))?.roles[0]?.roleCode;
    let { viewType, apkCreateUpdateFlag, createUpdateFlag, totalApkCountFlag } = props;
    const [apkMappingList, setApkMappingList] = useState([]);
    const [apkMappingSuccessMsg, setApkMappingSuccessMsg] = useState('');
    const [targetAllCdsns, setTargetAllCdsns] = useState(false);

    const [selectedValue, setSelectedValue] = useState({ cdsn: '', roomNo: '', apkVersion: '' });
    const [targetAllVersion, setTargetAllVersion] = useState('');
    const [targetFromVersion, setTargetFromVersion] = useState('');
    // const [expand, setExpand] = useState({ expandTrue: false });
    const [searchText, setSearchText] = useState("");
    const [searchTextValidation, setSearchTextValidation] = useState("");
    const [loader, setLoader] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [paginationError, setPaginationError] = useState("")
    const [inputPageValue, setInputPageValue] = useState(1)

    const [otp, setOtp] = useState("")
    const [otpValidation, setOtpValidation] = useState("")
    const [otpSendSuccess, setOtpSendSuccess] = useState("")
    const [otpSendError, setOtpSendError] = useState("")
    const [counter, setCounter] = useState(0)
    const [isLinkDisabled,setIsLinkDisabled] = useState(false)
    const [targetCdsnError, setTargetCdsnError] = useState("")

    const [fromApkVersion, setFromApkVersion] = useState([])
    const [debouncedSearchText, setDebouncedSearchText] = useState('');

    const [allCountSum, setAllCountSum] = useState(0)

    const {
        formState: { errors },
        control,
        watch,
        setValue
      } = useForm({
        mode: 'onChange',
      });

    const recordsPerPage = 10;
    let validPermissionClassName = isValidRole("HOTEL_CONFIGURATION_MODIFY")
        ? ""
        : "btn-disable-permission";

    const uploadApkListApi = () => {
        setLoader(true);
        const baseUrl = `/hotel/apk-mapping?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}&cdsn=${searchText ? searchText : ''}&apkVersion=${watch("apkVersionFilter")?watch("apkVersionFilter"):""}`;
       
        callAPI(baseUrl, "GET", {}, { chainId: getChainIdLS() })
            .then((response) => {
                setApkMappingList(response?.cdsnApkResponses?.map((data)=>({...data, expand: false})));
                setTotalPageCount(response?.totalPages ? response?.totalPages : 1);
                setPaginationError("");
                 setLoader(false);
            })
            .catch((err) => {
                console.warn(err.message);
                 setLoader(false);
            });
    };

    const { chainId } = useSelector((state) => state.chainIdReducer);


    useEffect(() => {
        if(searchTextValidation===""){
            uploadApkListApi();
        }    
    }, [apkCreateUpdateFlag, createUpdateFlag, chainId, selectedPage, debouncedSearchText, watch("apkVersionFilter")]);

    useEffect(() => {
        setSelectedPage(1);
        setTotalPageCount(1);
        setInputPageValue(1);
        setPaginationError("");
    }, [debouncedSearchText]);


    useEffect(() => {
        setSelectedValue({ cdsn: '', roomNo: '', apkVersion: '' });
        setSelectedPage(1);
        setTotalPageCount(1);
        setInputPageValue(1);
        setSearchText("")
        setDebouncedSearchText("")
    }, [chainId])

    const fromVersionApi = () =>{
        callAPI('/hotel/apk/fromVersion', "GET", {}, { chainId: getChainIdLS() })
        .then((response) => {
          setFromApkVersion(response?.map((data)=>({...data,key:data?.apkVersion?data?.apkVersion:"N.A"})))
          setAllCountSum(response?.reduce((acc,data)=>data.count+acc,0))
        })
        .catch((err) => console.warn(err.message));
    }

      useEffect(() => {
        fromVersionApi()
        setValue("apkVersionFilter", "")
      }, [createUpdateFlag,chainId]);

    const apkMappingHandler = (value, eventName) => {
        if (eventName === 'roomNo') {
            setSelectedValue((prev) => ({ ...prev, roomNo: value }))
        } else if (eventName === "apkVersion") {
            setSelectedValue((prev) => ({ ...prev, apkVersion: value === 'N.A' ? 'N.A' : value ? Number(value) : '' }))
        }
    }

    const targetDownloadHandler = () => {
        setLoader(true)
        callAPI('/hotel/apk-mapping', "PUT", selectedValue.apkVersion === "N.A" ? { ...selectedValue, apkVersion: null } : selectedValue, { chainId: getChainIdLS() })
            .then(function (response) {
                setApkMappingSuccessMsg(response?.message);
                uploadApkListApi();
                setSelectedValue({ cdsn: '', roomNo: '', apkVersion: '' });
                setLoader(false)
                fromVersionApi()
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false)
            });
    }

    const targetAllHelper = (val) =>{
        if (val==="N.A" || val==="") return null
        else if (val==="All") return -1
        else return val
    }

    const targetAllCdsnsHandler = () => {
        setLoader(true)
        const baseUrl = `${process.env.REACT_APP_BASE_URL}/hotel/apk/target-all`;
        const params = new URLSearchParams();
        
        // Add OTP only if targetAllVersion is "N.A"
        if (targetAllVersion === "N.A") {
            params.append('otp', otp);
        }
        
        // Add toVersion only if helper doesn't return null
        const toVersionValue = targetAllHelper(targetAllVersion);
        if (toVersionValue != null) {
            params.append('toVersion', toVersionValue);
        }
        
        // Add fromVersion only if helper doesn't return null
        const fromVersionValue = targetAllHelper(targetFromVersion);
        if (fromVersionValue != null) {
            params.append('fromVersion', fromVersionValue);
        }
        
        const url = `${baseUrl}?${params.toString()}`;
        // callAPI(url, "GET", {}, { chainId: getChainIdLS() })
        //     .then((response) => {
        //         setApkMappingSuccessMsg(response?.message);
        //         uploadApkListApi();
        //         setSelectedValue({ cdsn: '', roomNo: '', apkVersion: '' });
        //         setTargetAllVersion('');
        //         setLoader(false)
        //     })
        //     .catch((err) => { 
        //         console.warn(err.message);
        //         setLoader(false)
        //      });
             const requestHeaders = {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                  chainId: getChainIdLS()
                }
              };
          
              Axios.get(url, requestHeaders )
                .then(function (response) {
                    setApkMappingSuccessMsg(response?.data?.message);
                    uploadApkListApi();
                    setSelectedValue({ cdsn: '', roomNo: '', apkVersion: '' });
                    setTargetAllVersion('');
                    setTargetFromVersion("")
                    setLoader(false)
                    setTargetAllCdsns(false);
                    fromVersionApi()
                })
                .catch(function (error) {
                    console.warn(error.message);
                    setTargetCdsnError(error?.response?.data?.errorMessage)
                    setLoader(false)
                });
    }

    const expandHandler = (cdsn) => {
        setApkMappingList((prev) =>
            prev.map(item =>
                item.cdsn === cdsn
                    ? { ...item, expand: !item.expand } // create a new updated object
                    : item
            )
        );
    };

    //Pagination Handle changer
    const onPageChange = (event, value) => {
        setInputPageValue(value)
        setPaginationError("")
        setSelectedPage(value);
    };

    // Handle immediate input change for visual feedback
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchText(value); // Update immediately for UI responsiveness
        delayedSearch(value); // Trigger debounced validation
    };

       // Debounced function that updates the debounced state
        const delayedSearch = useCallback(
            debounce((value) => {
                if (/^\d*$/.test(value)) {
                    setDebouncedSearchText(value); // Only update debounced value when valid
                    setSearchTextValidation("");
                } else {
                    setSearchTextValidation("Please Enter Numbers Only");
                }
            }, 600),
            []
        );

    useEffect(()=>{
        if(otp.length<6){
            setOtpValidation("6 digit OTP Required")
        }
        else{
            setOtpValidation("")
        }
    },[otp])

    useEffect(() => {
        if (counter > 0) {
          const timeout = setTimeout(() => {
            setCounter((prevCounter) => prevCounter - 1);
          }, 1000);
          return () => {
            clearTimeout(timeout);
          };
        } else {
          setIsLinkDisabled(false);
          setOtpSendError("");
          setOtpSendSuccess("");
        }
      }, [counter]);

    const sendOtp = () =>{
        setLoader(true);
        setCounter(60);
        setIsLinkDisabled(true)
        setTargetCdsnError("")
        callAPI(`/generateOtp?operationType=TARGET_ALL_CDSN_TO_NA`, "POST", {} , { chainId: getChainIdLS() })
            .then((response) => {
                setOtpSendSuccess(response);
                setLoader(false);
            })
            .catch((err) => {
                console.warn(err.message);
                setOtpSendError(err.message)
                 setLoader(false);
            });
    }

    const clearData = ()=>{
        setOtp("")
        setIsLinkDisabled(false);
        setOtpSendError("");
        setOtpSendSuccess("");
        setOtpValidation("6 digit OTP Required")
        setTargetCdsnError("")
    }

    return (
        <>
            {(userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === "hotelApp") &&
                <div className="hotel-list">
                    <div className="flex-items-between mb-3">
                        <p className="mb-0"><b>CDSN's List</b></p>
                        <div className="flex-items-between">
                            {/* <Search
                                placeholder={"Search CDSN..."}
                                handleSearch={delayedSearch}
                                searchText={searchText}
                            /> */}
                            <div className="form-group-hotel hotel-list-form mb-0 col-4">
                                <div className="floating-select-label">
                                    <Controller
                                    name="apkVersionFilter"
                                    control={control}
                                    // rules={{
                                    //     validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select service type',
                                    // }}
                                    render={({ field }) => (
                                        <Autocomplete
                                        {...field}
                                        className={`multiselectlist ${field?.value ? 'Mui-focused' : ''}`}
                                        disablePortal
                                        options={fromApkVersion?.map((data)=>data.key)}
                                        getOptionLabel={(option) => option}
                                        onChange={(_, newValue) => {
                                            field.onChange(newValue);
                                            setSelectedPage(1);
                                            setTotalPageCount(1);
                                            setInputPageValue(1);
                                            setPaginationError("")
                                        }}
                                        value={field.value || ''}
                                        renderInput={(params) => (
                                            <TextField
                                            {...params}
                                            placeholder=""
                                            variant="outlined"
                                            label="Apk Version Filter"
                                            InputLabelProps={{
                                                shrink: false,
                                            }}
                                            />
                                        )}
                                        />
                                    )}
                                    />
                                </div>
                                {/* {errors.type && (
                                    <small className="required">{errors.type?.message}</small>
                                )} */}
                            </div>
                            <div className="form-group-hotel mb-0 col-3">
                                <div className={`floating-label`}>
                                    <input
                                        id="searchCdsn"
                                        maxLength={10}
                                        placeholder=""
                                        value={searchText}
                                        className="form-control"
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="guestName">Search CDSN...</label>
                                </div>
                                {searchTextValidation && (
                                    <small className="required">{searchTextValidation}</small>
                                )}
                            </div>
                            {isValidRole("HOTEL_CONFIGURATION_MODIFY") ? <Tooltip title={`${totalApkCountFlag ? "Please create APK configuration to Target Multiple CDSN's" : "Target Multiple CDSN's"}`} className="cursor-pointer" arrow>
                                <button disabled={totalApkCountFlag} type="button" className={`create-btn ${searchTextValidation!==""?"mb-4":""} ${totalApkCountFlag ? 'opacity-50' : ''}`} onClick={() => setTargetAllCdsns(true)}>Target Multiple CDSN's</button>
                            </Tooltip> : <Tooltip title="Don't have permission to Target Multiple CDSN's" arrow>
                                <button type="button" className={`create-btn ${searchTextValidation!==""?"mb-4":""} ${validPermissionClassName}`}>Target Multiple CDSN's</button>
                            </Tooltip>}
                        </div>
                    </div>
                    <div className="appPreference table-wrapper">
                        <TableContainer className="overflow-x-hidden">
                            <Table sx={{ minWidth: 650 }} aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>CDSN's</TableCell>
                                        <TableCell>RoomNo</TableCell>
                                        <TableCell>Current APK Version Code</TableCell>
                                        <TableCell>Update APK Version Code</TableCell>
                                        <TableCell>Actions</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                {loader ? <div style={{zIndex: "99999"}} className="circular-progress"><CircularProgress /></div> :
                                <>{!apkMappingList?.length ? (
                                    <TableBody className="hotel-table">
                                        <TableRow>
                                            <TableCell colSpan={"12"}>
                                                <Typography
                                                    variant="subtitle2"
                                                    className="text-center my-3"
                                                >
                                                    No Data Available...
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                ) : (
                                    <TableBody className="hotel-table">
                                        {apkMappingList?.map((cdsnList) => (
                                            <>
                                                <TableRow key={cdsnList?.cdsn}>
                                                    <TableCell>
                                                        {cdsnList?.cdsn}
                                                    </TableCell>
                                                    <TableCell className="w-25">
                                                        {selectedValue.cdsn === cdsnList?.cdsn ? (
                                                            <div className="w-50 d-flex">
                                                                <TextField
                                                                    name='roomNo'
                                                                    value={selectedValue.roomNo}
                                                                    inputProps={{ maxLength: 15 }}
                                                                    variant="outlined"
                                                                    className="appThresholdList bg-white"
                                                                    onChange={(e) => { apkMappingHandler(e.target.value, 'roomNo') }}
                                                                />

                                                                {((selectedValue.cdsn === cdsnList?.cdsn && (selectedValue?.apkVersion === '' || selectedValue?.apkVersion === null)) || selectedValue.roomNo === null) && <div className="action-items">
                                                                    <ClosedIcon
                                                                        fontSize={"2px"}
                                                                        onClick={() => {
                                                                            setSelectedValue({ cdsn: '', roomNo: '', apkVersion: '' });
                                                                        }}
                                                                        className="cursor-pointer xMark"
                                                                    />
                                                                    <FontAwesomeIcon
                                                                        icon={faCheck}
                                                                        className={`submit`}
                                                                        onClick={targetDownloadHandler}
                                                                    />
                                                                </div>}
                                                            </div>
                                                        ) : (
                                                            cdsnList?.roomNo ? cdsnList?.roomNo : 'N.A'
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {cdsnList?.apkVersion ? cdsnList?.apkVersion : 'N.A'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Tooltip title={`${selectedValue.cdsn === cdsnList?.cdsn ? '' : 'Click on Edit button to Update APK Version Code'}`} className="cursor-pointer w-100" arrow>
                                                            <div className="flex-item">
                                                                <Autocomplete
                                                                    value={selectedValue.cdsn === cdsnList?.cdsn ? selectedValue?.apkVersion : ''}
                                                                    onChange={(e) => apkMappingHandler(e.target.textContent, 'apkVersion')}
                                                                    options={[...cdsnList?.versions, 'N.A']}
                                                                    getOptionLabel={(option) => String(option) || ''}
                                                                    isOptionEqualToValue={(option, value) => String(option) === String(value)}
                                                                    renderInput={(params) => <TextField {...params} placeholder="Choose APK Version Code" />}
                                                                    className={`select-cdsn-list ${selectedValue.cdsn === cdsnList?.cdsn ? 'border-highlight' : ''} ${(selectedValue.cdsn === cdsnList?.cdsn && selectedValue?.apkVersion !== '' && selectedValue?.apkVersion !== null) ? 'w-25 me-2' : 'w-65'}`}
                                                                    disabled={selectedValue.cdsn === cdsnList?.cdsn ? false : true}
                                                                />
                                                                {(selectedValue?.apkVersion !== null && selectedValue?.apkVersion !== '' && selectedValue.cdsn === cdsnList?.cdsn) && <Tooltip title='Target Download' className="cursor-pointer" arrow>
                                                                    <button type="button"
                                                                        className='un-published'
                                                                        onClick={targetDownloadHandler}
                                                                    >
                                                                        Target Download
                                                                    </button>
                                                                </Tooltip>}
                                                            </div>
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell>

                                                        {isValidRole("HOTEL_CONFIGURATION_MODIFY") ? <Tooltip title="Edit" arrow>
                                                            <span><MdModeEditOutline
                                                                className="edit-icon-enable"
                                                                onClick={() => {
                                                                    setSelectedValue((prev) => ({ ...prev, cdsn: cdsnList?.cdsn, roomNo: cdsnList?.roomNo, apkVersion: cdsnList?.apkVersion }));
                                                                }}
                                                            /></span>
                                                        </Tooltip> : <Tooltip title="Don't have permission to edit" arrow>
                                                            <span>
                                                                <MdModeEditOutline className="edit-icon-disable" />
                                                            </span>
                                                        </Tooltip>}
                                                    </TableCell>
                                                    <TableCell>
                                                        <IconButton
                                                            aria-label="expand row"
                                                            size="small"
                                                            onClick={() => expandHandler(cdsnList?.cdsn)}
                                                        >
                                                            {cdsnList?.expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                                {cdsnList?.expand && <TableRow>
                                                    <TableCell colSpan={6} style={{ padding: '32px 16px 24px', backgroundColor: 'rgb(236, 238, 248)' }}>
                                                        <div className="row">
                                                            <div className="col-3">
                                                                <div className='row-summary-title'>Created By</div>
                                                                <div className='row-summary-value'>{cdsnList?.createdBy ? cdsnList?.createdBy : "N.A"}</div>
                                                            </div>
                                                            <div className="col-3">
                                                                <div className='row-summary-title'>Created Date</div>
                                                                <div className='row-summary-value'>{cdsnList?.createdOn ? `${dayjs(cdsnList?.createdOn).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(cdsnList?.createdOn).format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                                                            </div>
                                                            <div className="col-3">
                                                                <div className='row-summary-title'>Modified By</div>
                                                                <div className='row-summary-value'>{cdsnList.modifiedBy ? cdsnList.modifiedBy : "N.A"}</div>
                                                            </div>
                                                            <div className="col-3">
                                                                <div className='row-summary-title'>Modified Date</div>
                                                                <div className='row-summary-value'>{cdsnList?.modifiedOn ? `${dayjs(cdsnList?.modifiedOn).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(cdsnList?.modifiedOn).format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>}
                                            </>
                                        ))}
                                    </TableBody>
                                )}</>}
                            </Table>
                        </TableContainer>
                        <Custom_Paingation
                            selectedPage={selectedPage}
                            totalPageCount={totalPageCount}
                            paginationError={paginationError}
                            inputPageValue={inputPageValue}
                            setSelectedPage={setSelectedPage}
                            setPaginationError={setPaginationError}
                            setInputPageValue={setInputPageValue}
                            onPageChange={onPageChange}
                        />
                    </div>

                </div>}
            {apkMappingSuccessMsg !== "" && <BasicModal
                popupOpen={apkMappingSuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{apkMappingSuccessMsg}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setApkMappingSuccessMsg('') },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />}
            {targetAllCdsns && <BasicModal
                popupOpen={targetAllCdsns}
                popupSize = {"col-5"}
                // logo={"/Images/approve-qc.png"}
                bodyMessage={
                    <div className="cdsn-mapping-version w-75 m-0 m-auto">
                        <p className="mt-2 warning mb-0">This action will overwrite current APK Mapping for selected CDSNs.</p>
                        <p>To proceed further please select the APK version Code</p>
                        {targetFromVersion && <p className="text-bg-warning">{targetFromVersion=="All"?allCountSum:fromApkVersion?.find((data)=>data.key==targetFromVersion)?.count} boxes will be affected by choosing From APK Version as {targetFromVersion==="All"?"All CDSN's":targetFromVersion} </p>}
                        {otpSendSuccess && <p className="text-success text-capitalize">{otpSendSuccess}</p>}
                        {otpSendError && <p className="text-danger text-capitalize">{otpSendError}</p>}
                        {targetCdsnError && <p className="text-danger text-capitalize">{targetCdsnError}</p>}
                        <div className="row form-group-hotel">
                            <div className="col-6 floating-select-label">
                                <Autocomplete
                                value={targetFromVersion}
                                disableClearable
                                className={`multiselectlist select-apk-version ${targetFromVersion ? 'Mui-focused' : ''}`}
                                onChange={(e) => setTargetFromVersion(e.target.textContent)}
                                options={[...fromApkVersion?.map((data)=>data.key), 'All']}
                                getOptionLabel={(option) => String(option)}
                                isOptionEqualToValue={(option, value) => String(option) === String(value)}
                                renderInput={(params) => <TextField {...params} label="From Apk Version" InputLabelProps={{
                                    shrink: false,
                                }}/>}
                            />
                            {/* {otpValidation && (
                            <small className="text-white">{otpValidation}</small>
                            )} */}
                            </div>

                            <div className="col-6 floating-select-label">
                                <Autocomplete
                                value={targetAllVersion}
                                disableClearable
                                onChange={(e) => setTargetAllVersion(e.target.textContent)}
                                options={[...apkMappingList[0]?.versions, 'N.A']}
                                getOptionLabel={(option) => String(option)}
                                isOptionEqualToValue={(option, value) => String(option) === String(value)}
                                renderInput={(params) => <TextField {...params} label="To Apk Version" InputLabelProps={{
                                    shrink: false,
                                }}/>}
                                className={`multiselectlist select-apk-version ${targetAllVersion ? 'Mui-focused' : ''}`}
                            />
                            {/* {otpValidation && (
                            <small className="text-white">{otpValidation}</small>
                            )} */}
                            </div>
                        </div>
                        <div className="row mt-3">
                        {targetAllVersion === 'N.A' && <div className="form-group-hotel mb-0 col-6">
                        <div className={`floating-label`}>
                            <input
                            id="otp"
                            maxLength={6}
                            placeholder=""
                            value={otp}
                            className="form-control"
                            onChange={(e)=>setOtp(e.target.value)}
                            />
                            <label htmlFor="searchAction">Enter OTP</label>
                        </div>
                        {otpValidation && (
                        <small className="required text-start d-block mt-1">{otpValidation}</small>
                        )}
                        </div>
                        }
                        {targetAllVersion === 'N.A' && <div className="col-4 ps-0">
                            <button type="button" disabled={isLinkDisabled} onClick={sendOtp} className={`create-btn ${isLinkDisabled?"btn-disable opacity-50":""} ${otpValidation && isLinkDisabled?"":"mb-4"}`}>Send OTP</button>
                            {isLinkDisabled && (
                        <small className="required">Resend OTP in {counter} Sec</small>
                        )}
                        </div>}
                        </div>
                    </div>
                }
                footer={
                    {
                        primaryButton: {
                            buttonName: "Cancel",
                            action: () => { setTargetAllCdsns(false); setTargetAllVersion(''); setTargetFromVersion(""); clearData() }
                        },
                        secondaryButton: {
                            buttonName: "Target Download",
                            action: () => { targetAllCdsnsHandler(); clearData() },
                            buttonSecondaryCustomCss: (targetAllVersion === 'N.A' && otpValidation!=='') ? "btn-disable" : ""
                        }
                    }
                }
            />}

        </>
    )
}

export default CdsnsListMapping;